export default {
  "domain": "https://api-core-auth-v1-dev.azurewebsites.net/",
  "id": "tokowebdev",
  "secret": "3ZNdHR7kv0YXnrfrE9KykHsX8o7aFrev",
  "scopes": ["prosergate", "offline"]
}